// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2NVhO","inputWrap":"styles_inputWrap__vaZVr","input":"styles_input__1li52"};